import { render, staticRenderFns } from "./VueCheck.vue?vue&type=template&id=53dc8fa0&scoped=true&"
import script from "./VueCheck.vue?vue&type=script&lang=js&"
export * from "./VueCheck.vue?vue&type=script&lang=js&"
import style0 from "./VueCheck.vue?vue&type=style&index=0&id=53dc8fa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dc8fa0",
  null
  
)

export default component.exports